import { NftCategory } from '@milestone-portal/common/enums';
import { z } from 'zod';

export const LoginSearchSchema = z.object({
  code: z.string().optional(),
  from: z.string().catch(''),
  state: z.string().optional(),
});

export const OfflineSearchSchema = z.object({
  from: z.string(),
  search: z.record(z.string(), z.any()).optional(),
});

export const ProfileSearchSchema = z.object({
  category: z.nativeEnum(NftCategory).optional().catch(NftCategory.ACHIEVEMENT),
  date: z
    .object({
      end: z.string(),
      start: z.string(),
    })
    .optional(),
  limit: z.number().optional().catch(10),
  school: z.array(z.string()).optional().catch([]),
  search: z.string().optional().catch(''),
  sort: z.string().optional().catch(''),
  type: z.array(z.string()).optional().catch([]),
});
